import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

// Styled Components with Premium Medical Design
export const ReservationContainer = styled("div")(({ theme }) => ({
  background: "linear-gradient(135deg, #f8fffe 0%, #ffffff 100%)",
  minHeight: "100vh",
  padding: "32px 20px",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      "radial-gradient(ellipse at top, rgba(124, 200, 144, 0.05) 0%, transparent 70%)",
    pointerEvents: "none",
  },

  "@media (max-width: 768px)": {
    padding: "32px 1px",
  },
}));

export const MainCard = styled("div")(({ theme }) => ({
  background:
    "linear-gradient(145deg, #ffffff 0%, rgba(248, 255, 254, 0.9) 100%)",
  borderRadius: "32px",
  boxShadow:
    "0 32px 80px rgba(5, 50, 81, 0.08), 0 16px 40px rgba(5, 50, 81, 0.04)",
  border: "1px solid rgba(124, 200, 144, 0.1)",
  padding: "48px 32px",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "8px",
    background: "linear-gradient(90deg, #053251 0%, #7cc890 100%)",
    borderRadius: "32px 32px 0 0",
  },
  "@media (max-width: 768px)": {
    background: "transparent",
    boxShadow: "none",
    border: "none",
    padding: "0",
    borderRadius: "0",
    "&::before": {
      display: "none",
    },
  },
}));

export const SectionHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: "32px",
  position: "relative",
  "& span": {
    fontSize: "32px",
    fontWeight: "700",
    background: "linear-gradient(135deg, #053251 0%, #2a5a72 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    letterSpacing: "-1px",
    position: "relative",
    paddingRight: "24px",
  },
  "&::before": {
    content: '""',
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    width: "8px",
    height: "48px",
    background:
      "linear-gradient(180deg, #7cc890 0%, rgba(124, 200, 144, 0.3) 100%)",
    borderRadius: "4px",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: "-12px",
    right: "24px",
    left: 0,
    height: "2px",
    background: "linear-gradient(90deg, #7cc890 0%, transparent 100%)",
    borderRadius: "1px",
  },
  "@media (max-width: 768px)": {
    marginBottom: "24px",
    "& span": {
      fontSize: "24px",
    },
  },
}));

export const ScrollContainer = styled("div")(({ theme }) => ({
  display: "flex",
  overflowX: "auto",
  touchAction: "pan-x",
  width: "100%",
  paddingBottom: "16px",
  gap: "16px",
  scrollBehavior: "smooth",

  // Desktop scrollbar (همون قبلی)
  "&::-webkit-scrollbar": {
    height: "8px",
  },
  "&::-webkit-scrollbar-track": {
    background: "rgba(5, 50, 81, 0.05)",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "linear-gradient(90deg, #7cc890 0%, #053251 100%)",
    borderRadius: "4px",
    "&:hover": {
      background: "linear-gradient(90deg, #6bb57f 0%, #2a5a72 100%)",
    },
  },
  scrollbarWidth: "thin",
  scrollbarColor: "#7cc890 rgba(5, 50, 81, 0.05)",

  "@media (max-width: 768px)": {
    paddingBottom: "20px",
    touchAction: "pan-x",

    "&::-webkit-scrollbar": {
      height: "10px",
      WebkitAppearance: "none",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(124, 200, 144, 0.1)",
      borderRadius: "5px",
      border: "1px solid rgba(124, 200, 144, 0.15)",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "linear-gradient(90deg, #7cc890 0%, #6bb57f 100%)",
      borderRadius: "5px",
      border: "2px solid rgba(255, 255, 255, 0.5)",
      minWidth: "40px",
    },
    "&::-webkit-scrollbar-thumb:active": {
      background: "linear-gradient(90deg, #6bb57f 0%, #5aa46e 100%)",
    },

    // Firefox
    scrollbarWidth: "auto",
    scrollbarColor: "#7cc890 rgba(124, 200, 144, 0.1)",

    overflowX: "scroll",
    WebkitOverflowScrolling: "touch",
  },
}));

export const EmptyStateCard = styled("div")(({ theme }) => ({
  background:
    "linear-gradient(135deg, rgba(255, 107, 107, 0.03) 0%, rgba(255, 107, 107, 0.01) 100%)",
  border: "2px dashed rgba(255, 107, 107, 0.2)",
  borderRadius: "20px",
  padding: "48px 32px",
  textAlign: "center",
  margin: "32px 0",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-2px",
    left: "-2px",
    right: "-2px",
    bottom: "-2px",
    background:
      "linear-gradient(135deg, rgba(255, 107, 107, 0.1), transparent)",
    borderRadius: "22px",
    zIndex: -1,
  },
  "& span": {
    // fontSize: "18px",
    // color: "#053251",
    // fontWeight: "500",
    // display: "block",
    // marginBottom: "24px",
  },
  "@media (max-width: 768px)": {
    background:
      "linear-gradient(145deg, #ffffff 0%, rgba(248, 255, 254, 0.9) 100%)",
    border: "2px dashed rgba(255, 107, 107, 0.3)",
    borderRadius: "20px",
    boxShadow:
      "0 16px 40px rgba(5, 50, 81, 0.08), 0 8px 20px rgba(5, 50, 81, 0.04)",
    padding: "32px 20px",
    margin: "0",
    "&::before": {
      background:
        "linear-gradient(135deg, rgba(255, 107, 107, 0.05), transparent)",
    },
    "& span": {
      fontSize: "16px",
    },
  },
}));

export const StyledButton = styled(Button)(
  ({ theme, variant: buttonVariant, color }) => ({
    borderRadius: "16px",
    padding: "10px 40px",
    fontSize: "16px",
    fontWeight: "600",
    textTransform: "none",
    letterSpacing: "0.5px",
    minWidth: "160px",
    position: "relative",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "none",
    ...(color === "success" && {
      background: "linear-gradient(135deg, #7cc890 0%, #6bb57f 100%)",
      color: "white",
      border: "1px solid rgba(124, 200, 144, 0.3)",
      "&:hover": {
        background: "linear-gradient(135deg, #6bb57f 0%, #5aa46e 100%)",
        boxShadow: "0 16px 32px rgba(124, 200, 144, 0.3)",
        transform: "translateY(-3px)",
      },
      "&:active": {
        transform: "translateY(-1px)",
      },
    }),
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: "16px",
      padding: "1px",
      background:
        "linear-gradient(135deg, rgba(124, 200, 144, 0.4), transparent)",
      mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      maskComposite: "xor",
      WebkitMask:
        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "xor",
    },
    "& .MuiButton-startIcon, & .MuiButton-endIcon": {
      transition: "transform 0.3s ease",
    },
    "&:hover .MuiButton-endIcon": {
      transform: "translateX(-4px)",
    },
    "@media (max-width: 768px)": {
      padding: "14px 32px",
      fontSize: "15px",
    },
  })
);

export const ReservationSection = styled("div")(({ theme }) => ({
  marginBottom: "48px",
  position: "relative",
  "&:not(:last-child)::after": {
    content: '""',
    position: "absolute",
    bottom: "-24px",
    left: "0",
    right: "0",
    height: "1px",
    background:
      "linear-gradient(90deg, transparent 0%, rgba(124, 200, 144, 0.2) 50%, transparent 100%)",
  },
  "@media (max-width: 768px)": {
    background:
      "linear-gradient(145deg, #ffffff 0%, rgba(248, 255, 254, 0.9) 100%)",
    borderRadius: "24px",
    boxShadow:
      "0 16px 40px rgba(5, 50, 81, 0.08), 0 8px 20px rgba(5, 50, 81, 0.04)",
    border: "1px solid rgba(124, 200, 144, 0.1)",
    padding: "24px 15px",
    marginBottom: "24px",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "4px",
      background: "linear-gradient(90deg, #053251 0%, #7cc890 100%)",
      borderRadius: "24px 24px 0 0",
    },
    "&:not(:last-child)::after": {
      display: "none",
    },
  },
}));

export const FinalActionContainer = styled("div")(({ theme }) => ({
  background:
    "linear-gradient(135deg, rgba(124, 200, 144, 0.05) 0%, rgba(5, 50, 81, 0.02) 100%)",
  borderRadius: "24px",
  padding: "32px",
  marginTop: "48px",
  border: "1px solid rgba(124, 200, 144, 0.1)",
  textAlign: "center",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "60px",
    height: "4px",
    background: "linear-gradient(90deg, #7cc890 0%, #053251 100%)",
    borderRadius: "2px",
  },
  "@media (max-width: 768px)": {
    background:
      "linear-gradient(145deg, #ffffff 0%, rgba(248, 255, 254, 0.9) 100%)",
    borderRadius: "24px",
    boxShadow:
      "0 16px 40px rgba(5, 50, 81, 0.08), 0 8px 20px rgba(5, 50, 81, 0.04)",
    border: "1px solid rgba(124, 200, 144, 0.1)",
    padding: "24px 20px",
    marginTop: "24px",
    "&::before": {
      width: "40px",
      height: "3px",
    },
  },
}));

export const LoaderContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "200px",
  position: "relative",
}));
